import { Box, Stack } from '@mui/material';
import type { FC } from 'react';

import { CardSanity } from '~/components/molecules/CardSanity';
import { PAGE_CONTENT_MAX_WIDTH } from '~/constants';
import type { CardListProps } from '~/types/sanity/components';
import { getCompoundTestIdGenerator } from '~/utils/getCompoundTestIdGenerator';

/**
 * Displays a list of cards. Sanity validation ensures min 1 card / max 2 cards.
 */
export const CardList: FC<Omit<CardListProps, '_key' | '_type'>> = ({ cards, isAuthenticated }) => {
  const getCompoundTestId = getCompoundTestIdGenerator('cardList');

  return (
    <Box sx={{ paddingX: { xs: 2, sm: 5 }, paddingY: 6 }}>
      <Stack
        data-testid={getCompoundTestId()}
        sx={{
          flexDirection: { xs: 'column', sm: 'row' },
          gap: ({ spacing }) => spacing(3),
          justifyContent: 'center',
          margin: '0 auto',
          maxWidth: PAGE_CONTENT_MAX_WIDTH,
        }}
      >
        {cards.map(({ _key, cardColor, icon, links, paragraph, title }, index) => (
          <Box data-testid={getCompoundTestId(`card-${index}`)} key={_key} sx={{ flex: 1, maxWidth: 600 }}>
            <CardSanity
              cardColor={cardColor}
              icon={icon}
              isAuthenticated={isAuthenticated}
              links={links}
              paragraph={paragraph}
              title={title}
            />
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
